module.exports = __webpack_public_path__ + "static/media/Coaching in Leadership.340bd4b1.pdf";